import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// ----------------------------------------------------------------------
// 1. إعدادات الاتصال بالسيرفر (Axios)
// ----------------------------------------------------------------------
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// ----------------------------------------------------------------------
// 2. إنشاء الـ Thunk للقيام بالعملية غير المتزامنة (إرسال الطلب)
// ----------------------------------------------------------------------
export const submitEvaluations = createAsyncThunk(
    'assessment/submitEvaluations',
    async (payload, { rejectWithValue }) => {
        try {
            // إرسال الـ POST Request. التخلص من السلاش المزدوج
            const url = `${BASE_URL}assessment-results`;
            const response = await axios.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    // إذا كان لديك توكن للمصادقة يمكنك إضافته هنا:
                    'Authorization': `Bearer ${localStorage.getItem('userToken')}` 
                }
            });
            return response.data; // البيانات الراجعة عند النجاح
        } catch (error) {
            // معالجة الخطأ وإرجاع رسالة واضحة للواجهة
            if (error.response) {
                // الخطأ قادم من السيرفر (مثلاً 400 أو 500)
                const data = error.response.data;
                if (data.errors) return rejectWithValue(Object.values(data.errors).flat().join(' - '));
                if (data.message) return rejectWithValue(data.message);
                return rejectWithValue(`خطأ من السيرفر: ${error.response.status}`);
            } else if (error.request) {
                // الطلب لم يصل للسيرفر
                return rejectWithValue('تعذر الوصول إلى السيرفر، تحقق من اتصالك بالإنترنت.');
            }
            return rejectWithValue(error.message || 'حدث خطأ غير متوقع.');
        }
    }
);

// ----------------------------------------------------------------------
// 3. إنشاء الـ Slice لإدارة حالة الـ Redux
// ----------------------------------------------------------------------
const assessmentSlice = createSlice({
    name: 'assessment',
    initialState: {
        status: 'idle', // الحالات الممكنة: 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
    },
    reducers: {
        // إجراء لتصفير الحالة (مفيد عند إغلاق رسالة الخطأ أو إعادة المحاولة)
        resetSubmissionState: (state) => {
            state.status = 'idle';
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(submitEvaluations.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(submitEvaluations.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.error = null;
            })
            .addCase(submitEvaluations.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload; // الرسالة التي أرسلناها بـ rejectWithValue
            });
    }
});

// ----------------------------------------------------------------------
// 4. تصدير الإجراءات (Actions) والمحددات (Selectors) والـ Reducer
// ----------------------------------------------------------------------

// تصدير الإجراءات العادية
export const { resetSubmissionState } = assessmentSlice.actions;

// تصدير المحددات لقراءتها في واجهة المستخدم
export const selectSubmissionStatus = (state) => state.assessment.status;
export const selectSubmissionError = (state) => state.assessment.error;

// التصدير الافتراضي للـ Reducer لربطه بالـ Store
export default assessmentSlice.reducer;